const isLocalhost = Boolean(
  window.location.hostname === 'localhost'
  || window.location.hostname === '[::1]'
  || window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/)
);

const dispatchPwaEvent = (type, detail = {}) => {
  window.dispatchEvent(new CustomEvent(type, { detail }));
};

const registerValidServiceWorker = (swUrl) => {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;

        installingWorker.onstatechange = () => {
          if (installingWorker.state !== 'installed') return;

          if (navigator.serviceWorker.controller) {
            dispatchPwaEvent('foth:pwa-update-ready', { registration });
          } else {
            dispatchPwaEvent('foth:pwa-cached', { registration });
          }
        };
      };
    })
    .catch((error) => {
      console.error('FOTH service worker registration failed:', error);
    });
};

const checkValidServiceWorker = (swUrl) => {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404
        || (contentType && !contentType.includes('javascript'))
      ) {
        navigator.serviceWorker.ready
          .then((registration) => registration.unregister())
          .then(() => window.location.reload());
        return;
      }

      registerValidServiceWorker(swUrl);
    })
    .catch(() => {
      dispatchPwaEvent('foth:pwa-offline-ready');
    });
};

export const register = () => {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    if (isLocalhost) {
      checkValidServiceWorker(swUrl);
    } else {
      registerValidServiceWorker(swUrl);
    }
  });
};

export const requestServiceWorkerUpdate = (registration) => {
  if (!registration?.waiting) {
    return;
  }

  registration.waiting.postMessage({ type: 'SKIP_WAITING' });
};
